export default __webpack_public_path__ + "maps-examples-multiple-shapes-1200-2105be3e245dc1ee25c655116fa1d981.webp";